import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useClientProject } from '../../modules/dashboard/hooks/useClientProject'
import { FullPageLoader, FullPageMessage } from '../components/FullPageState'
import { ProjectContext } from './ProjectContext'

/**
 * Carrega o projeto da URL uma única vez e disponibiliza para os filhos via
 * useProject(). Substitui o padrão antigo em que toda página chamava
 * useClientProject(useParams().id) independentemente.
 */
export function ProjectProvider({ children }) {
  const { id } = useParams()
  const projectId = Number(id)
  const { data, isLoading, error } = useClientProject(projectId)

  if (isLoading) return <FullPageLoader label="Carregando projeto..." />
  if (error) {
    return (
      <FullPageMessage
        title="Falha ao carregar o projeto"
        message={error?.message ?? 'Tente recarregar a página.'}
      />
    )
  }
  if (!data) {
    return (
      <FullPageMessage
        title="Projeto não encontrado"
        message="Este projeto não existe ou foi removido."
      />
    )
  }

  return (
    <ProjectContext.Provider value={{ project: data, projectId }}>
      {children}
    </ProjectContext.Provider>
  )
}

/**
 * Acessa o projeto atual a partir do contexto.
 * Falha se usado fora de <ProjectProvider>.
 */
export function useProject() {
  const ctx = useContext(ProjectContext)
  if (!ctx) {
    throw new Error('useProject() chamado fora de <ProjectProvider>')
  }
  return ctx
}
